import DocumentsContainer from './DocumentsContainer';

export default DocumentsContainer;
